








































































































































































































































































import ViewModel from "@/views/contact/Question";
export default ViewModel;
